import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WipFavoriteView } from '@app/logic/wip/wip.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { CbTruncateModule } from '@app/shared/pipe/truncate/truncate.module';

@Component({
    selector: 'cb-side-panel',
    templateUrl: './side-panel.component.html',
    styleUrls: ['./side-panel.component.scss'],
    imports: [
        MatCardModule,
        MatIconModule,
        CommonModule,
        MatTooltipModule,
        MatDividerModule,
        MatButtonModule,
        MatListModule,
        MatSidenavModule,
        MatSlideToggleModule,
        CbTruncateModule,
    ]
})
export class SidePanelComponent {
    @Input() favoriteViews: WipFavoriteView[] = [];
    public collapsed = true;
    @Input() public selectedId = '';
    @Input() public isEditMode = false;
    @Output() viewSelected = new EventEmitter<WipFavoriteView>();
    @Output() modeChanged = new EventEmitter<boolean>();
    @Output() addNewClicked = new EventEmitter<void>();
    @Output() deleteView = new EventEmitter<WipFavoriteView>();
    constructor() {
    }

    public selectView(view: WipFavoriteView): void {
        this.viewSelected.emit(view);
        this.selectedId = view.id;
        this.collapsed = !this.collapsed;
        this.onEditModeChange(false);
    }

    public onEditModeChange(isEditMode: boolean): void {
        this.isEditMode = isEditMode;
        this.modeChanged.emit(this.isEditMode);
    }

    public addNewView(): void {
        this.addNewClicked.emit();
        this.selectedId = '';
        this.onEditModeChange(true);
    }

    public onDeleteView(view: WipFavoriteView, event: Event): void {
        event.stopPropagation();
        this.deleteView.emit(view);
    }

    public editClick(view: WipFavoriteView, $event: MouseEvent): void {
        this.selectView(view);
        this.onEditModeChange(true);
    }
}
